// ── (2026-07-22 Viajes) Nodo `/viajes` — agencias de viaje / boletería aérea ──
//
// FUENTE ÚNICA en el frontend de los 15 campos del nodo `/viajes` de la norma
// SENIAT (tabla de validaciones L542-L556). Espeja `_VIAJE_CAMPOS_API` del
// backend (optimus_invoice/factura_routes.py): MISMO orden de la norma, MISMAS
// claves snake_case y MISMAS longitudes máximas. Se centraliza aquí para que el
// formulario de proformas, las vistas de detalle y el PDF no puedan divergir
// entre sí ni respecto del backend.
//
// Longitudes: copiadas literalmente de la norma. `hora_salida` / `hora_llegada`
// son 11 (no 10) por la errata de la norma: su propio ejemplo '00:00:00 am' mide
// 11 caracteres y truncar a 10 destruiría el marcador am/pm.
//
// NO se impone un formato canónico de fecha/hora: la norma no lo fija y el
// backend almacena y emite el valor VERBATIM tal como lo envía el emisor. Por
// eso los 15 campos son inputs de texto (no `type="date"`/`type="time"`), lo que
// además permite aplicar la convención UpperCase del proyecto a todos ellos.
//
//   key   → clave snake_case que viaja en el payload y devuelve el schema.
//   label → etiqueta visible (formulario, detalle, PDF).
//   max   → longitud máxima de la norma (= ancho de la columna en BD).
//   ancho → clase de columna del formulario (identidad gráfica del proyecto).
//   hint  → placeholder del input.
export const VIAJE_CAMPOS = [
  { key: 'nombre_apellido_pasajero',     label: 'Nombre y apellido del pasajero',   max: 100, ancho: 'lg:w-4/12',  hint: 'NOMBRE Y APELLIDO' },
  { key: 'tipo_identificacion',          label: 'Tipo de identificación',           max: 1,   ancho: 'lg:w-2/12',  hint: 'V / E / J / P' },
  { key: 'numero_identificacion',        label: 'Número de identificación',         max: 12,  ancho: 'lg:w-3/12',  hint: 'SOLO DÍGITOS' },
  { key: 'numero_tele_pasajero',         label: 'Teléfono del pasajero',            max: 255, ancho: 'lg:w-3/12',  hint: '0000-0000000' },
  { key: 'domicilio_fiscal_pasajero',    label: 'Domicilio fiscal del pasajero',    max: 255, ancho: 'lg:w-12/12', hint: 'DIRECCIÓN FISCAL' },
  { key: 'razon_social_serv_transporte', label: 'Razón social del transportista',   max: 100, ancho: 'lg:w-6/12',  hint: 'LÍNEA AÉREA' },
  { key: 'numero_boleto',                label: 'Número de boleto',                 max: 14,  ancho: 'lg:w-3/12',  hint: 'Nº DE BOLETO' },
  { key: 'nombre_puerto_embarque',       label: 'Puerto de embarque',               max: 255, ancho: 'lg:w-3/12',  hint: 'AEROPUERTO' },
  { key: 'fecha_salida',                 label: 'Fecha de salida',                  max: 10,  ancho: 'lg:w-3/12',  hint: 'DD/MM/AAAA' },
  { key: 'hora_salida',                  label: 'Hora de salida',                   max: 11,  ancho: 'lg:w-3/12',  hint: '08:30:00 am' },
  { key: 'fecha_llegada',                label: 'Fecha de llegada',                 max: 10,  ancho: 'lg:w-3/12',  hint: 'DD/MM/AAAA' },
  { key: 'hora_llegada',                 label: 'Hora de llegada',                  max: 11,  ancho: 'lg:w-3/12',  hint: '11:45:00 am' },
  { key: 'punto_salida',                 label: 'Punto de salida',                  max: 255, ancho: 'lg:w-4/12',  hint: 'CIUDAD / ORIGEN' },
  { key: 'punto_destino',                label: 'Punto de destino',                 max: 255, ancho: 'lg:w-4/12',  hint: 'CIUDAD / DESTINO' },
  { key: 'condiciones_entrega',          label: 'Condiciones de entrega',           max: 255, ancho: 'lg:w-4/12',  hint: 'CONDICIONES' },
];

// Fila de boleto vacía (las 15 claves en cadena vacía). El backend persiste
// `null` para los campos sin dato y DESCARTA la fila si todas están vacías.
export const nuevoViajeVacio = () =>
  VIAJE_CAMPOS.reduce((acc, f) => ({ ...acc, [f.key]: '' }), {});

// true si el boleto tiene al menos un dato (criterio del backend para persistir
// la fila y para contar "al menos un viaje" cuando es boletería aérea).
export const viajeTieneDatos = (viaje) =>
  VIAJE_CAMPOS.some((f) => String(viaje?.[f.key] ?? '').trim() !== '');
